import { ChannelTheme, IChannelTypeOptions, IScreen } from 'src/modules/Redux';

export const getDefaultBgColor = (theme: ChannelTheme) =>
    theme === ChannelTheme.LIGHT ? '#FBF9F5' : '#000000';
export const getDefaultProductNameTextColor = (theme: ChannelTheme) =>
    theme === ChannelTheme.LIGHT ? '#0F0F0F' : '#FFFFFF';
export const getDefaultProductPriceTextColor = (theme: ChannelTheme) =>
    theme === ChannelTheme.LIGHT ? '#5E6166' : '#FFFFFF';
export const getDefaultTileBgColor = (theme: ChannelTheme) =>
    theme === ChannelTheme.LIGHT ? '#F5F2EA' : '#2C2C2C';

export const getChannelOptions = <T extends keyof IChannelTypeOptions>(
    channel: T,
    screen?: IScreen | null
) => {
    let channelOptions: IChannelTypeOptions[T] | undefined = undefined;

    if (screen && screen.channelOptions) {
        channelOptions = screen.channelOptions.find(
            ch => ch.channel === channel
        )?.options;
    }

    return {
        unwrap: () => channelOptions,
        getOrDefault<
            TProp extends keyof IChannelTypeOptions[T],
            TValue extends IChannelTypeOptions[T][TProp]
        >(prop: TProp, value: TValue) {
            if (!channelOptions || !(prop in channelOptions)) {
                return value;
            }

            return channelOptions[prop];
        },
    };
};
